import { CheckoutCustomerDetails } from '../checkout-customer/checkout-customer-details.interface';
import { CheckoutItemDetails } from '../checkout-item/checkout-item-details.interface';
import { CheckoutPaymentDetails } from '../checkout-payment/checkout-payment-details.type.';

export interface CheckoutRequest {
  basketId: string;
  customer: CheckoutCustomerDetails;
  items: CheckoutItemDetails[];
  payment: CheckoutPaymentDetails;
}
